import { render, staticRenderFns } from "./Icon2.vue?vue&type=template&id=8a08ffa4&scoped=true&"
import script from "./Icon2.vue?vue&type=script&lang=js&"
export * from "./Icon2.vue?vue&type=script&lang=js&"
import style0 from "./Icon2.vue?vue&type=style&index=0&id=8a08ffa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a08ffa4",
  null
  
)

export default component.exports